/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable quote-props */
/* eslint-disable quotes */
/* eslint no-param-reassign: "error" */
import { gql } from 'apollo-boost';
import FetchApi, { setLanguage } from '../fetch-api/fetch-api';
import getConfig from '../env';
import {
  getIsEclientToken,
  setCookie,
  getTime,
  getCookie,
  getValueFromUrl,
  setCoreAuthToken,
  getSpecificUrl,
  getIsCC
} from '../fetch-api/lib/auth-token';
import { getProductRoadMapUpdates, EclientFooter, IntegrationSettings } from './sub-links';
import Icon from '../components/icon/icon.js';
import styles from '../components/menu/menu.css';
import { displaySessionExpireInfo } from '../components/sessionexpire/sessionexpire.js';
import { clientGateway } from '../utils/actions';
import { getNameInitials, setUserName, getUserName, imageExists, setClientLogoUrl } from '../utils/utils';

import {
  selectCompiledCatalogLink,
  selectTransformedAwards,
  selectTransformedBanks,
  selectTransformedCatalogs,
  selectLogoutLinks,
  selectCompiledAlertsCount,
  selectCompiledGenericAlertsArray,
  selectCompiledReceiveAlertsArray
} from '../selectors/layouts.js';

let storage = {};
try {
  storage = window.localStorage;
} catch (e) {
  // eslint-disable-next-line no-console
  console.log(e);
}

let coreUserPreferredLang = '';
let currentApp = '';
let layoutsVision = {};
let personalInfoLanguage = '';

let fetchEclientTokenAttempts = 0;

let isWindowAddEventListenerInitialized = false;
let isTokenApiPending = false;
let isLogoutActionPage = false;

let logoutStorageKey = 'logout_user';

let tokenExpiresIn = '';

let timeOutSession;
let isPreferredLanguageDataReceived = false;

const budgetOverviewId = 'BUDGET_MANAGEMENT_OVERVIEW';
const budgetManagementId = 'BUDGET_MANAGEMENT';
const budgetSegmentReportId = 'BUDGET_SEGMENT_REPORT';
const invoiceSpreadsheet = 'invoice-spreadsheet';
const invoiceSpreadSheetId = 'INVOICE_SPREADSHEET';
const adminIntegrationsId = 'ADMIN_INTEGRATIONS_SETTINGS';
const transBillingDashboardKey = 'billing-dashboard';
const budgetFundRequestId = 'BUDGET_MANAGEMENT_FUND_REQUEST';
const customReportObj = {
  name: 'data-export-tool',
  id: 'DATA_EXPORT_TOOL'
};
const currentAppObj = ['DATA_EXPORT_TOOL', 'DASHBOARDS', 'MANAGE_ACCESS', 'STORE'];
const budgetFundRequestPath = 'budgetFundRequest';
const roadMapPath = 'octannerroadmap';
const groupDepositsPath = getConfig('GROUP_DEPOSITS_BASE_PATH') || 'groupdeposits';
const landingPagePaths = ['/admin/', '/sender/', '/manager/', '/recipient/'];

const semanticBlueColor = '#0060E0';
export const semanticBlueApps = ['groupdeposits', 'useractivity', 'adminhome', 'recognitionmgmt'];
const translationsFakeData = {
  reporting: 'Reporting',
  'data-export-tool': 'Data Export Tool',
  'manage-access': 'Manage Access',
  dashboards: 'Dashboards',
  'sign-out': 'Sign Out',
  'budget-management-overview': 'Budget Overview',
  'show-celebrations-store-viewer': 'Celebrations Store Viewer'
};

export const reportingId = 'REPORTING';

export const getAppPrimaryColor = (clientColorVal = '') => {
  const { location: { pathname = '' } = {} } = window;
  let appPrimaryColor = clientColorVal;
  if (pathname) {
    semanticBlueApps.forEach((appPathName) => {
      if (pathname.indexOf(appPathName) !== -1) {
        appPrimaryColor = semanticBlueColor;
      }
    });
  }
  return appPrimaryColor;
};

export const getClientColor = (clientFirstColor, defaultColorValue) => {
  if (clientFirstColor && clientFirstColor.length > 0) {
    return clientFirstColor;
  }
  return defaultColorValue;
};

export const doLogout = (logoutLink) => {
  const dt = new Date();
  isLogoutActionPage = true;
  storage.setItem(logoutStorageKey, `logout_user_${dt.getTime()}`);
  window.location.href = logoutLink;
};

export const setCurrentApp = (x) => {
  currentApp = x;
};
const isGroupDepositsLandingPages = () => {
  const { location: { pathname = '' } = {} } = window;
  let val = false;
  if (landingPagePaths && pathname) {
    landingPagePaths.forEach((path) => {
      if (pathname.indexOf(`${groupDepositsPath}${path}`) !== -1) {
        val = true;
      }
    });
  }
  return val;
};

const skipAdminAuthToken = () => {
  const mainPathName = window.location.pathname.split('/')[2];
  const adminAuthSkipPaths = getConfig('ADMIN_AUTH_ESCAPE_PATHS').split(',');
  return ((adminAuthSkipPaths.indexOf(mainPathName) > -1) || isGroupDepositsLandingPages());
};

export const isDisplayHeader = () => {
  const mainPathName = window.location.pathname.split('/')[2];
  const displayHeaderPaths = getConfig('DISPLAY_HEADER').split(',');
  return displayHeaderPaths.indexOf(mainPathName) > -1;
};

export const isDisplayFooter = () => (isDisplayHeader() || isGroupDepositsLandingPages());

export const isCCApp = () => {
  const normalUrlMatch = getConfig('NORMAL_URL_MATCH');
  const { location: { origin = '' } } = window;
  if (origin.indexOf(normalUrlMatch) === -1) {
    return true;
  }
  return false;
};

export const getTranslationText = (obj, translations) => {
  if (!obj) {
    return false;
  }
  const item = obj;
  if (typeof translations[item.name] !== 'undefined') {
    item.name = translations[item.name];
  } else {
    item.name = translationsFakeData[item.name] ? translationsFakeData[item.name] : item.name;
  }
  return item;
};

export const getCCPrismTheme = (dispatch, language, customerId, identityUuid) => {
  const defaultColorValue = '#000';
  const themeQuery = gql`
  query VibeGetDerivedVibeDetails($input: VibeGetDerivedVibeDetailsInput!) {
    vibeGetDerivedVibeDetails(input: $input) {
      attributes {
        color {
          clientColor
        }
        image {
          companyLogo
        }
      }
    }
  }
`;

  clientGateway(getConfig('GATEWAY_API_URL'))
    .query({
      query: themeQuery,
      variables: {
        "input": {
          "companyId": customerId,
          "language": language,
          "userId": identityUuid
        }
      }
    }).then((result = {}) => {
      const { data } = result || {};
      const { vibeGetDerivedVibeDetails } = data || {};
      const { attributes } = vibeGetDerivedVibeDetails || {};
      const { color, image } = attributes || {};
      const { clientColor = '' } = color || {};
      const { companyLogo = '' } = image || {};
      if (isCCApp()) {
        setClientLogoUrl(companyLogo);
      } else {
        setClientLogoUrl('');
      }
      const primaryHexColor = getClientColor(clientColor, defaultColorValue);
      const secondaryHexColor = getClientColor(clientColor, defaultColorValue);
      const clientColors = {
        primary: getAppPrimaryColor(primaryHexColor),
        secondary: secondaryHexColor
      };
      dispatch({
        type: 'SET_CLIENT_COLORS',
        payload: {
          data: clientColors,
          status: 200
        }
      });
    }).catch(() => {
      const clientColors = {
        primary: defaultColorValue,
        secondary: defaultColorValue
      };
      dispatch({
        type: 'SET_CLIENT_COLORS',
        payload: {
          data: clientColors,
          status: 200
        }
      });
    });
};

export const getCommonHeaderData = (dispatch) => (
  FetchApi(`${getConfig('API_BASE_URL')}/layouts`).then((data) => {
    dispatch({
      type: 'SET_LOGO',
      payload: {
        data: data.logo,
        status: 200
      }
    });
    dispatch({
      type: 'SET_GLOBAL_MENU',
      payload: {
        data: data.subscriptions,
        status: 200
      }
    });
    if (!isCCApp()) {
      dispatch({
        type: 'SET_CLIENT_COLORS',
        payload: {
          data: data.color,
          status: 200
        }
      });
    }
    return data;
  })
);

function getPersonalInfoApiUrl() {
  let url = `/perf/users/accounts/personalInfo?noncache=${getTime()}`;
  const { origin = '' } = window.location;
  const normalUrlMatch = getConfig('NORMAL_URL_MATCH');
  if (origin.indexOf(normalUrlMatch) === -1) {
    url = `/api${url}`;
  } else {
    url = `${getConfig('VISION_LAYOUTS_API')}${url}`;
  }
  return url;
}

export function savePreferredLanguage() {
  return new Promise(((resolve, reject) => {
    const lang = {
      preferredLanguageLocale: getCookie('language')
    };
    const options = {
      method: 'put',
      body: JSON.stringify(lang)
    };
    FetchApi(getPersonalInfoApiUrl(), options).then((data) => {
      resolve(data);
    }).catch((err) => {
      reject(err);
    });
  }));
}


export function getLayouts() {
  return new Promise(((resolve, reject) => {
    FetchApi(`${getSpecificUrl('VISION_LAYOUTS_API')}/layout/vision`).then((data) => {
      resolve(data);
    }).catch((err) => {
      reject(err);
    });
  }));
}

function getAlerts() {
  return new Promise(((resolve, reject) => {
    FetchApi(`${getSpecificUrl('VISION_LAYOUTS_API')}/layout/alerts`).then((data) => {
      resolve(data);
    }).catch((err) => {
      reject(err);
    });
  }));
}

function fetchTasks() {
  return new Promise(((resolve, reject) => {
    FetchApi(`${getSpecificUrl('VISION_LAYOUTS_API')}/give/currentTasksCount?nocache=${getTime()}`).then((data) => {
      resolve(data);
    }).catch((err) => {
      reject(err);
    });
  }));
}

function filteredProductRoadMapUpdates() {
  const isProductRoadmapEnabled = getConfig('PRODUCT_ROADMAP_ENABLED');
  let roadmapUpdates = getProductRoadMapUpdates();
  if (isProductRoadmapEnabled === 'false') {
    roadmapUpdates = roadmapUpdates.filter((data) => data.id !== 'PRODUCT_ROADMAP');
  }
  return roadmapUpdates;
}

function getPermissionLinks() {
  return new Promise((async (resolve, reject) => {
    let keyCode = '';
    if (getIsCC()) {
      keyCode = await FetchApi(`${getConfig('CC_DOMAIN')}/api/ucatgateway/v1/viewOnly/loadCustomerData`, {}, false, 'post', {}, false, true);
    }
    FetchApi(`${getSpecificUrl('AUTHORIZE_USER_TOKEN_API')}/authorize`).then((data) => {
      const isVictoriesApp = !getIsCC();
      const result = data.activities;
      let celebrationsStoreViewerIndex = -1;
      let isroadmaplinksloaded = false;
      let celebrationsStoreViewer = null;
      if (result && result[0]) {
        let reloadPage = true;
        let childs = result[0].children;
        const pathValue = window.location.pathname;
        const mainPathName = pathValue.split('/')[2];
        const escPaths = getConfig('ROUTE_ESCAPE_PATHS');
        result[0].children.forEach((item) => {
          if (isVictoriesApp && item.id === 'EMPLOYEE_ACTIVITY_HISTORY') {
            item.url = '/ui/useractivity/';
          } else if (item.id === 'SHOW_CELEBRATIONS_STORE_VIEWER' && !isVictoriesApp) {
            item.url += `?key=${keyCode}`;
            item.target = '_blank';
          }
        });
        if (result[0] && result[0].children) {
          celebrationsStoreViewerIndex = result[0].children.findIndex((item) => item.id === "SHOW_CELEBRATIONS_STORE_VIEWER");
          celebrationsStoreViewer = celebrationsStoreViewerIndex !== -1 ? result[0].children[celebrationsStoreViewerIndex] : null;
          result[0].children = result[0].children.filter((item) => item.id !== 'SHOW_CELEBRATIONS_STORE_VIEWER');
        }
        let isEscapeCheckPath = false;
        if (escPaths) {
          isEscapeCheckPath = escPaths.split(',').indexOf(mainPathName) > -1;
        }
        const isLocalhost = window.location.href.indexOf('localhost') > 0;
        if (!isEscapeCheckPath && mainPathName && !isLocalhost) {
          const urlSubPath = mainPathName;
          if (urlSubPath) {
            childs.forEach((item) => {
              if (item.url.indexOf(urlSubPath) !== -1) {
                reloadPage = false;
              }
            });
          }
          // const len = window.location.pathname.split('/').length;
          // const endPathIndex = len - 1;
          // const subPathName = window.location.pathname.split('/')[endPathIndex];
          // if (subPathName !== '' && subPathName.length !== 0) {
          //   if (subPathName === roadMapPath) {
          //     reloadPage = false;
          //   }
          //   if (len > 2) {
          //     const mainSubPath = window.location.pathname.split('/')[len - 2];
          //     if (mainSubPath !== '' && mainSubPath !== undefined && mainPathName.length !== 0) {
          //       if (escPaths.split(',').indexOf(mainSubPath) > -1) {
          //         reloadPage = false;
          //       }
          //     }
          //   }
          // }
          isroadmaplinksloaded = true;
          result[0].children = [...result[0].children, ...JSON.parse(JSON.stringify(filteredProductRoadMapUpdates()))];
          const fullPath = window.location.pathname;
          childs = result[0].children;
          if (!reloadPage && childs[0] && childs[0].name === 'product-roadmap' && fullPath.indexOf(roadMapPath) === -1) {
            reloadPage = true;
          }
          if (reloadPage) {
            if (pathValue.indexOf(roadMapPath) > -1) {
              reloadPage = false;
            }
          }
          if (reloadPage && !isVictoriesApp && celebrationsStoreViewerIndex !== -1 && childs[0] && childs[0].name === 'product-updates') {
            reloadPage = false;
            if (!(window.location.href.includes('/adminhome/store')) && window.location.href.includes('/adminhome')) {
              window.location.href += 'store';
            }
          }
          if (reloadPage && childs[0]) {
            if (childs[0].url && childs[0].url.indexOf(budgetFundRequestPath) === -1) {
              window.location.href = childs[0].url;
            } else if (childs[1] && childs[1].url) {
              window.location.href = childs[1].url;
            }
          }
        }
      }
      if (!isroadmaplinksloaded) {
        if (result && result.length > 0) {
          result[0].children = [...result[0].children, ...JSON.parse(JSON.stringify(filteredProductRoadMapUpdates()))];
        }
      }

      if (!isVictoriesApp && celebrationsStoreViewerIndex !== -1 && celebrationsStoreViewer !== null && result[0] && result[0].children) {
        result[0].children.push(celebrationsStoreViewer);
      }

      result[0].children.forEach((item) => {
        const record = item;
        if (item.id === 'ADMIN_INTEGRATIONS_SETTINGS') {
          const integrationSettingsObj = IntegrationSettings;
          integrationSettingsObj.forEach((integration) => {
            integration.url = item.url + integration.url;
          });
          record.children = integrationSettingsObj;
        }
      });
      resolve(data);
    }).catch((err) => {
      reject(err);
    });
  }));
}

export function getLanguageStrings() {
  return new Promise(((resolve, reject) => {
    FetchApi(`${getConfig('VISON_LAYOUTS_TRANSLATIONS_API')}/translations/0001543530/commonui/`).then((data) => {
      resolve(data);
    }).catch((err) => {
      reject(err);
    });
  }));
}

function getEclientLinkToken() {
  const options = {
    credentials: 'include'
  };
  return new Promise(((resolve, reject) => {
    FetchApi(`${getConfig('ECLIENT_TOKEN_LINK')}?noncache=${getTime()}`, options, true).then((data) => {
      resolve(data);
    }).catch((err) => {
      fetchEclientTokenAttempts += 1;
      if (fetchEclientTokenAttempts === 3) {
        reject(err);
      } else {
        getEclientLinkToken().then((data) => {
          resolve(data);
        }).catch((errRes) => {
          reject(errRes);
        });
      }
    });
  }));
}

function getCoreAuthToken() {
  const options = {
    credentials: 'include'
  };
  return new Promise((resolve, reject) => {
    FetchApi(`${getConfig('COMMON_UI_JACKET_URL')}/token/${getTime()}`, options, true).then((data) => {
      resolve(data);
    }).catch((err) => {
      reject(err);
    });
  });
}

function checkRetryFetchEclientToken() {
  return new Promise(((resolve, reject) => {
    const tokenEclientParam = getConfig('TOKEN_ECLIENT_PARAM');
    if (getValueFromUrl(tokenEclientParam)) {
      const eclientToken = getValueFromUrl(tokenEclientParam);
      resolve(eclientToken);
    } else if (getCookie(tokenEclientParam)) {
      const eclientCookieToken = getCookie(tokenEclientParam);
      resolve(eclientCookieToken);
    } else {
      getEclientLinkToken().then((data) => {
        const parseData = JSON.parse(data);
        const { authToken = '' } = parseData;
        resolve(authToken);
      }).catch((err) => {
        reject(err);
      });
    }
  }));
}

function getUserPreferredLanguage(dispatch) {
  return new Promise(((resolve) => {
    if (isCCApp()) {
      const identitySearchQuery = gql`
        query {
          currentIdentity {
            firstName
            lastName
            language
            customerId
            identityUuid
          }
        }
      `;
      clientGateway(getConfig('GATEWAY_API_URL'))
        .query({
          query: identitySearchQuery
        }).then((result = {}) => {
          const {
            data: {
              currentIdentity: {
                firstName = '',
                lastName = '',
                language = '',
                customerId = '',
                identityUuid = ''
              }
            }
          } = result;
          const userName = `${firstName} ${lastName}`;
          setUserName(userName);
          isPreferredLanguageDataReceived = true;
          resolve({
            ccPreferredLanguage: language
          });
          getCCPrismTheme(dispatch, language, customerId, identityUuid);
        }).catch(() => {
          const result = {
            defaultLanguage: getConfig('APPLICATION_LANGUAGE')
          };
          setCookie('language', result.defaultLanguage);
          resolve(result);
        });
    } else {
      FetchApi(getPersonalInfoApiUrl()).then((data) => {
        const { firstName: { value: firstNameValue = '' }, lastName: { value: lastNameValue = '' } } = data;
        const userName = `${firstNameValue} ${lastNameValue}`;
        setUserName(userName);
        isPreferredLanguageDataReceived = true;
        resolve(data);
      }).catch(() => {
        const result = {
          defaultLanguage: getConfig('APPLICATION_LANGUAGE')
        };
        setCookie('language', result.defaultLanguage);
        resolve(result);
      });
    }
  }));
}

function getAvatar() {
  return new Promise(((resolve) => {
    if (isCCApp()) {
      const identitySearchQuery = gql`
        query {
          currentIdentity {
            firstName
            lastName
            profile {
              avatar
            }
          }
        }
      `;
      clientGateway(getConfig('GATEWAY_API_URL'))
        .query({
          query: identitySearchQuery
        }).then((result = {}) => {
          const {
            data: {
              currentIdentity: {
                firstName = '',
                lastName = '',
                profile: { avatar = '' }
              }
            }
          } = result;
          const userName = `${firstName} ${lastName}`;
          setUserName(userName);
          resolve(avatar);
        }).catch(() => {
          resolve('');
        });
    } else {
      FetchApi(`${getSpecificUrl('VISION_LAYOUTS_API')}/perf/users/accounts/avatar`).then((data = {}) => {
        const { user: { avatars } } = data;
        const { original, profile, thumb } = avatars;
        let userAvatar = '';
        if (profile) {
          userAvatar = profile;
        } else if (thumb) {
          userAvatar = thumb;
        } else if (original) {
          userAvatar = original;
        }
        resolve(userAvatar);
      }).catch(() => {
        resolve('');
      });
    }
  }));
}

function getRefreshToken() {
  const options = {
    credentials: 'include'
  };
  return new Promise((resolve, reject) => {
    FetchApi(`${getConfig('COMMON_UI_JACKET_URL')}/refreshToken`, options, true).then((data) => {
      resolve(data);
    }).catch((err) => {
      reject(err);
    });
  });
}

async function setPreferredLanguageInfo(res, dispatch) {
  let lang = '';
  if (res && res[0]) {
    if (!isCCApp()) {
      const languageObj = res[0].preferredLanguageId;
      if (languageObj && languageObj.options && languageObj.value) {
        const obj = languageObj.options.find((item) => languageObj.value === item.value);
        if (obj && obj.locale) {
          lang = obj.locale;
          personalInfoLanguage = lang;
        }
      } else if (res && res[0] && res[0].defaultLanguage) {
        lang = res[0].defaultLanguage;
        personalInfoLanguage = lang;
      }
    } else {
      const { ccPreferredLanguage = '' } = res[0];
      lang = ccPreferredLanguage || (navigator && navigator.languages
        ? navigator.languages[0]
        : navigator.language);
      lang = lang || getConfig('APPLICATION_LANGUAGE');
      coreUserPreferredLang = lang;
    }
  }
  lang = lang.replace('-', '_');
  setLanguage(lang);
  setCookie('language', lang);
  dispatch({ type: 'SET_APPLICATION_LANGUAGE', payload: lang });
}

function getLayoutsPermissions(isTokenRefresh, dispatch) {
  fetchEclientTokenAttempts = 0;
  const { href = '' } = window.location;
  const normalUrlMatch = getConfig('NORMAL_URL_MATCH');
  setClientLogoUrl('');
  if (isTokenRefresh) {
    if (href.indexOf(normalUrlMatch) === -1) {
      getRefreshToken().then((data) => {
        setCoreAuthToken(data.token);
        tokenExpiresIn = data.expiresIn;
        return Promise.all([getPermissionLinks()]);
      });
    } else {
      return Promise.all([getPermissionLinks()]);
    }
  } else if (href.indexOf(normalUrlMatch) === -1) {
    // eslint-disable-next-line consistent-return
    return getCoreAuthToken().then((data) => {
      if (data.isRedirectUrl) {
        window.location.href = data.coreAuthUrl;
      } else {
        setCoreAuthToken(data.token);
        tokenExpiresIn = data.expiresIn;
        if (getCookie('language') && isPreferredLanguageDataReceived) {
          personalInfoLanguage = getCookie('language');
          if (skipAdminAuthToken()) {
            return Promise.all([{}, getLanguageStrings(), getLayouts(), getAvatar()]);
          }
          return Promise.all([getPermissionLinks(), getLanguageStrings(), getLayouts(), getAvatar()]);
        }
        return Promise.all([getUserPreferredLanguage(dispatch)])
          .then((res) => {
            setPreferredLanguageInfo(res, dispatch);
            if (skipAdminAuthToken()) {
              return Promise.all([{}, getLanguageStrings(), getLayouts(), getAvatar()]);
            }
            return Promise.all([getPermissionLinks(), getLanguageStrings(), getLayouts(), getAvatar()]);
          })
          .catch((err) => err);
      }
    }).catch((err) => err);
  } else if (getIsEclientToken()) {
    return Promise.all([checkRetryFetchEclientToken()])
      .then((eclientToken) => {
        let [token = ''] = eclientToken;
        if (token && token.indexOf('Bearer ') !== -1) {
          token = token.replace('Bearer ', '');
        }
        setCookie('_eclientlink_access_token', token);
        return Promise.all([getPermissionLinks(), getLanguageStrings()]);
      })
      .catch((err) => err);
  } else if (getCookie('language') && isPreferredLanguageDataReceived) {
    personalInfoLanguage = getCookie('language');
    if (skipAdminAuthToken()) {
      return Promise.all([{}, getLanguageStrings(), getLayouts(), getAvatar()]);
    }
    return Promise.all([getPermissionLinks(), getLanguageStrings(), getLayouts(), getAvatar()]);
  }
  return Promise.all([getUserPreferredLanguage(dispatch)])
    .then((res) => {
      setPreferredLanguageInfo(res, dispatch);
      if (skipAdminAuthToken()) {
        return Promise.all([{}, getLanguageStrings(), getLayouts(), getAvatar()]);
      }
      return Promise.all([getPermissionLinks(), getLanguageStrings(), getLayouts(), getAvatar()]);
    })
    .catch((err) => err);
}

function getActivity(layouts, subscriptionItem, children) {
  const matchString = getConfig('BIND_ACTIVITIES_MENU_MATCH');
  let menuMatchStrings = [];
  if (matchString) {
    menuMatchStrings = matchString.split(',');
  }
  const subscription = subscriptionItem;
  const { activity = [] } = layouts;
  const mediaSideArr = [];
  activity.forEach((x) => {
    const obj = {
      name: x.title,
      url: x.link
    };
    if (x.link.indexOf(menuMatchStrings[2]) !== -1) {
      obj.specialClass = 'tasks-link';
    }
    if (x.link.indexOf(menuMatchStrings[0]) !== -1 && x.submenu === undefined) {
      subscription.children = children;
      obj.children = [];
      obj.isExpanded = true;
      obj.children.push(subscriptionItem);
    }
    if (x.submenu) {
      obj.children = [];
      x.submenu.forEach((y) => {
        const objInner = {
          name: y.title,
          url: y.link
        };
        if (y.link.indexOf(menuMatchStrings[1]) !== -1) {
          objInner.children = children;
        }
        obj.children.push(objInner);
        if (y.submenu) {
          const lastChild = obj.children;
          lastChild[lastChild.length - 1].children = [];
          y.submenu.forEach((z) => {
            const objLast = {
              name: z.title,
              url: z.link
            };
            lastChild[lastChild.length - 1].children.push(objLast);
          });
        }
      });
    }
    mediaSideArr.push(obj);
  });
  return mediaSideArr;
}

function getBanks(banks, awards, catalogs, translations) {
  const banksObj = {
    name: `${translations.catalog} (${banks[0].points})`,
    url: '',
    isDisplayMiniScreen: true,
    children: [
      {
        name: banks[0].isPointsBank ? translations['bank-accounts'] : translations['access-codes'],
        url: '',
        children: []
      }
    ]
  };
  banks.forEach((x) => {
    const objItem = {
      name: `<i class="${styles.sideCurrentBank}">${x.isCurrentBank ? Icon('check') : ''}</i> ${x.name} (${x.points})`,
      url: x.link,
      id: `${x.isCurrentBank ? 'check' : ''}`
    };
    banksObj.children[0].children.push(objItem);
  });

  if (awards.length > 0) {
    const objAwards = {
      name: translations['unredeemed-awards'],
      url: '',
      children: []
    };
    awards.forEach((x) => {
      const objItem = {
        name: x.name,
        url: x.link
      };
      objAwards.children.push(objItem);
    });
    banksObj.children.push(objAwards);
  }

  if (catalogs.length > 0) {
    const objCatalogs = {
      name: translations['view-awards'],
      url: '',
      children: []
    };

    catalogs.forEach((x) => {
      const objItem = {
        name: x.title,
        url: x.link
      };
      objCatalogs.children.push(objItem);
    });

    banksObj.children.push(objCatalogs);
  }
  return banksObj;
}

async function getGreeting(layouts, avatar, translations) {
  let avatarUrl = avatar;
  if (avatar && (avatar.indexOf('default/profile.') !== -1 || avatar.indexOf('default/thumb.') !== -1)) {
    avatarUrl = '';
  }
  if (avatarUrl) {
    const isImageExist = await (imageExists(avatarUrl));
    avatarUrl = isImageExist ? avatarUrl : '';
  }
  const { logout = {} } = layouts;
  const obj = {
    name: 'sign-out'
  };
  const { name = '' } = getTranslationText(obj, translations);
  const userName = getUserName();
  const greeting = {
    name: userName,
    nameInitials: getNameInitials(userName, isCCApp()),
    url: '',
    image: avatarUrl,
    logoutTitle: name,
    logoutLink: logout.link
  };
  return greeting;
}

export const dispatchContextMenu = (dispatch, arr, url, count) => {
  arr.map((item) => {
    const specItem = item;
    if (specItem.url.indexOf(url) !== -1) {
      specItem.name = `${specItem.name} ${count > 0 ? `(${count})` : ''}`;
    }
    return specItem;
  });

  dispatch({
    type: 'SET_CONTEXT_MENU',
    payload: {
      data: arr,
      status: 200
    }
  });
};

export const refreshToken = (dispatch) => {
  const timestamp = Math.round(new Date() / 1000) + (parseInt(getConfig('TOKEN_EXPIRATION_MINUTES'), 10) * 60);
  if (tokenExpiresIn < timestamp) {
    if (!isTokenApiPending) {
      isTokenApiPending = true;
      const obj = {
        isRefreshToken: true
      };
      dispatch({
        type: 'REFRESH_AUTH_TOKEN',
        payload: {
          data: obj,
          status: 200
        }
      });
    }
  }
};

export const dispatchSessionExtendDialog = (dispatch) => {
  if (timeOutSession) {
    clearTimeout(timeOutSession);
    if (!skipAdminAuthToken()) {
      refreshToken(dispatch);
    }
  }
  timeOutSession = setTimeout(() => {
    // eslint-disable-next-line no-use-before-define
    handleSessionExtend(dispatch, true);
  }, getConfig('ADMIN_AUTH_TIME_RECALL'));
};

export const handleSessionExtend = (dispatch, isDisplay) => {
  const obj = {
    isDisplaySession: isDisplay
  };

  dispatch({
    type: 'SET_SESSION_EXTEND_DIALOG',
    payload: {
      data: obj,
      status: 200
    }
  });
  if (!isDisplay) {
    dispatchSessionExtendDialog(dispatch);
  }
};

export const getUserCommonHeaderData = (dispatch, isTokenRefresh) => (
  getLayoutsPermissions(isTokenRefresh, dispatch)
    .then(([permissionLinks = {}, translations = {}, layouts = {}, avatar = {}]) => {
      if (layouts) {
        layoutsVision = layouts;
      }
      if (!layoutsVision.theme) {
        layoutsVision.theme = {
          primaryHexColor: 'D3D3D3' // light grey
        };
      }

      if (layouts && layouts.customerName) {
        dispatch({
          type: 'CUSTOMER_NAME',
          payload: {
            data: layouts.customerName,
            status: 200
          }
        });
      }
      const result = Object.assign({}, permissionLinks, layoutsVision);

      if (result && result.token) {
        setCookie('_admin_auth_token', `Bearer ${result.token}`);
        tokenExpiresIn = result.expiresIn;
        result.preferredLanguagePersonalInfo = personalInfoLanguage;
        result.browserLanguage = coreUserPreferredLang;
        result.coreUserPreferredLang = coreUserPreferredLang;
      }
      if (!isTokenRefresh) {
        const matchString = getConfig('BIND_ACTIVITIES_MENU_MATCH');
        let menuMatchStrings = [];
        if (matchString) {
          menuMatchStrings = matchString.split(',');
        }
        const { activities = [{ children: [], adminHome: {} }] } = permissionLinks;
        const { theme = {} } = layoutsVision;
        let { footer = [] } = layoutsVision;
        const { activity = [] } = layoutsVision;
        const { hasGiveWidgetEnabled } = layoutsVision;
        const { cart = {} } = layoutsVision;
        const { link = '' } = cart;
        const catalogLink = selectCompiledCatalogLink(layoutsVision);
        const awards = selectTransformedAwards(layoutsVision);
        const banks = selectTransformedBanks(layoutsVision);
        const catalogs = selectTransformedCatalogs(layoutsVision);
        const logout = selectLogoutLinks(layoutsVision);
        const { primaryHexColor = '', secondaryHexColor = '', logoUrl = '' } = theme;
        let { children = [] } = activities[0];
        const { ...adminHome } = activities[0];
        let isDisplayBudgetManagement = false;
        const globalMenu = [];
        const subscriptionItem = getTranslationText(adminHome, translations);
        globalMenu.push(subscriptionItem);

        if (getIsEclientToken()) {
          const [firstChild = []] = children;
          const { id = '' } = firstChild;
          if (id === invoiceSpreadSheetId) {
            setCurrentApp(invoiceSpreadSheetId);
            dispatch({
              type: 'SET_CURRENT_APPLICATION',
              payload: {
                data: invoiceSpreadSheetId,
                status: 200
              }
            });
          }
        }

        children.forEach((x, i) => {
          let obj = children[i];
          if (invoiceSpreadsheet === obj.name) {
            obj.name = translations[transBillingDashboardKey];
          }
          if (adminIntegrationsId === obj.id) {
            x.children.forEach((item, index) => {
              const record = getTranslationText(item, translations);
              // eslint-disable-next-line no-param-reassign
              x.children[index] = record;
            });
          }
          if (x.id === reportingId) {
            const currentItem = x;
            if (currentItem.children) {
              currentItem.children.forEach((childObj) => {
                if (childObj.id === budgetSegmentReportId) {
                  const childItem = childObj;
                  childItem.name = customReportObj.name;
                  childItem.id = customReportObj.id;
                }
                if (childObj.id === currentApp) {
                  const childItem = childObj;
                  childItem.isCurrent = true;
                  obj.isExpanded = true;
                }
                let y = childObj;
                y = getTranslationText(Object.assign({}, y), translations);
                const childItem = childObj;
                childItem.name = y.name;
              });
            }
          }


          // if (x.id === budgetSegmentReportId) {
          //   obj.name = customReportObj.name;
          //   obj.id = customReportObj.id;
          // }

          if (x.id === budgetManagementId) {
            const currentItem = x;
            if (currentItem.children) {
              if (currentItem.children.length > 0) {
                isDisplayBudgetManagement = true;
                const isContainsBudgetFundRequest = currentItem.children.filter((item) => item.id === budgetFundRequestId).length > 0;
                if (isContainsBudgetFundRequest && currentItem.children.length === 1) {
                  isDisplayBudgetManagement = false;
                } else {
                  currentItem.children = currentItem.children.filter((item) => item.id !== budgetFundRequestId);
                }
              }
              currentItem.children.forEach((childObj) => {
                if (childObj.id === currentApp) {
                  const childItem = childObj;
                  childItem.isCurrent = true;
                  obj.isExpanded = true;
                }
                let y = childObj;
                y = getTranslationText(Object.assign({}, y), translations);
                const childItem = childObj;
                childItem.name = y.name;
              });
            }
          }
          if (obj.id === currentApp || (obj.id === reportingId && currentAppObj.indexOf(currentApp) !== -1)) {
            obj.isCurrent = true;
            if (obj.children && obj.children.length > 0) {
              obj.isExpanded = true;
            }
          }
          if (obj.id === currentApp || (obj.id === budgetManagementId && currentApp === budgetOverviewId)) {
            obj.isCurrent = true;
            if (obj.children && obj.children.length > 0) {
              obj.isExpanded = true;
            }
          }
          obj = getTranslationText(obj, translations);
          obj.isDisplayMax = true;
        });
        if (!isDisplayBudgetManagement) {
          children = children.filter((item) => item.id !== budgetManagementId);
        }
        subscriptionItem.isExpanded = true;
        if (!globalMenu.children) {
          getActivity(layouts, subscriptionItem, children);
        }
        const arrChild = isDisplayHeader() ? children.concat(getActivity(layouts, subscriptionItem, children)) : children;
        getGreeting(layouts, avatar, translations).then((resObj) => {
          dispatch({
            type: 'GREETING',
            payload: {
              data: resObj,
              status: 200
            }
          });
        }).catch(() => {
          const userName = getUserName();
          const obj = { name: 'sign-out' };
          const { name = '' } = getTranslationText(obj, translations);
          const { logout: logoutData = {} } = layouts;
          const defaultObj = {
            name: userName,
            nameInitials: getNameInitials(userName, isCCApp()),
            url: '',
            image: '',
            logoutTitle: name,
            logoutLink: logoutData.link
          };
          dispatch({
            type: 'GREETING',
            payload: {
              data: defaultObj,
              status: 200
            }
          });
        });

        if (!getIsEclientToken()) {
          const objNotifications = {
            name: `${translations.notifications}`,
            url: '/ui/greatwork/history.html',
            isDisplayMiniScreen: true
          };
          if (isDisplayHeader()) {
            arrChild.push(objNotifications);
          }

          if (cart.link) {
            const objCart = {
              name: translations['shopping-cart'],
              url: cart.link,
              id: 'shoppingCart',
              isDisplayMiniScreen: true
            };
            if (isDisplayHeader()) {
              arrChild.push(objCart);
            }
          }

          if (banks && banks[0] && isDisplayHeader()) {
            arrChild.push(getBanks(banks, awards, catalogs, translations));
          }

          fetchTasks().then((res) => {
            const { currentTasksCount } = res;
            if (currentTasksCount > 0) {
              dispatch({
                type: 'TASKS_COUNT',
                payload: {
                  data: res,
                  status: 200
                }
              });
              if (isDisplayHeader()) {
                dispatchContextMenu(dispatch, arrChild, menuMatchStrings[2], currentTasksCount);
              }
            }
          }).catch((err) => {
            // eslint-disable-next-line no-console
            console.log(err);
          });
          if (isDisplayHeader()) {
            getAlerts().then((alerts) => {
              const alertsCount = selectCompiledAlertsCount(alerts);
              const genericAlerts = selectCompiledGenericAlertsArray(alerts);
              const receiveAlerts = selectCompiledReceiveAlertsArray(alerts);
              dispatch({
                type: 'ALERTS_COUNT',
                payload: {
                  data: alertsCount,
                  status: 200
                }
              });
              dispatch({
                type: 'GENERIC_ALERTS',
                payload: {
                  data: genericAlerts,
                  status: 200
                }
              });
              dispatch({
                type: 'RECEIVE_ALERTS',
                payload: {
                  data: receiveAlerts,
                  status: 200
                }
              });
              dispatchContextMenu(dispatch, arrChild, '/history', alertsCount);
            }).catch((err) => {
              // eslint-disable-next-line no-console
              console.log(err);
            });
          }
        } else {
          const eclientFooterArr = [].concat(EclientFooter);
          eclientFooterArr.forEach((item) => {
            const rec = item;
            rec.link = getConfig(rec.env_val);
          });
          footer = eclientFooterArr;
        }

        const color = {
          primary: getAppPrimaryColor(`#${primaryHexColor}`),
          secondary: `#${secondaryHexColor}`
        };
        const logo = {
          url: logoUrl
        };

        activity.map((item) => {
          const specItem = item;
          if (specItem.link.indexOf(menuMatchStrings[2]) !== -1) {
            specItem.specialClass = 'tasks-link';
          }
          return specItem;
        });

        result.globalMenu = globalMenu;

        dispatch({
          type: 'HAS_WIDGET_ENABLED',
          payload: {
            data: hasGiveWidgetEnabled,
            status: 200
          }
        });
        dispatch({
          type: 'TRANSLATIONS_UPDATED',
          payload: {
            data: translations,
            status: 200
          }
        });

        dispatch({
          type: 'SET_LOGO',
          payload: {
            data: logo,
            status: 200
          }
        });
        dispatch({
          type: 'ACTIVITY_MENU',
          payload: {
            data: activity,
            status: 200
          }
        });
        dispatch({
          type: 'CART_LINK',
          payload: {
            data: link,
            status: 200
          }
        });
        dispatch({
          type: 'CATALOG_LINK',
          payload: {
            data: catalogLink,
            status: 200
          }
        });
        if (!getIsEclientToken()) {
          dispatch({
            type: 'BANKS_CATALOG',
            payload: {
              data: banks,
              status: 200
            }
          });
        }
        dispatch({
          type: 'SET_GLOBAL_MENU',
          payload: {
            data: globalMenu,
            status: 200
          }
        });
        if (!isCCApp()) {
          dispatch({
            type: 'SET_CLIENT_COLORS',
            payload: {
              data: color,
              status: 200
            }
          });
        }
        dispatchContextMenu(dispatch, arrChild);

        if (isDisplayFooter()) {
          dispatch({
            type: 'FOOTERLINKS',
            payload: {
              data: footer,
              status: 200
            }
          });
        }

        dispatch({
          type: 'LOGOUT',
          payload: {
            data: logout,
            status: 200
          }
        });
        dispatch({
          type: 'AWARDS',
          payload: {
            data: awards,
            status: 200
          }
        });
        dispatch({
          type: 'CATALOGS',
          payload: {
            data: catalogs,
            status: 200
          }
        });
        dispatch({
          type: 'RECEIVE_ALERTS',
          payload: {
            data: [],
            status: 200
          }
        });
        dispatchSessionExtendDialog(dispatch);
        if (!isWindowAddEventListenerInitialized) {
          isWindowAddEventListenerInitialized = true;
          window.addEventListener('mouseup', () => {
            dispatchSessionExtendDialog(dispatch);
          });
          window.addEventListener('keyup', () => {
            dispatchSessionExtendDialog(dispatch);
          });
          window.addEventListener('storage', (e) => {
            if (getIsEclientToken()) {
              logoutStorageKey = `${logoutStorageKey}_yearbook`;
            }
            if (e.key === logoutStorageKey && !isLogoutActionPage) {
              const { link: logoutLinkUrl = '' } = logout;
              displaySessionExpireInfo(logoutLinkUrl, translations);
            }
          });
        }
      }
      result.isRefresh = isTokenRefresh;
      isTokenApiPending = false;
      return result;
    }).catch((err) => err)
);
